import { types } from 'mobx-state-tree';

export const uploadFileProgress = types
  .model({
    fileUUID: types.maybeNull(types.string),
    uploadValue: types.maybeNull(types.number),
  })
  .views(self => ({
    get getUploadFileProgress() {
      return self.uploadValue;
    },
    get getFileUUID() {
      return self.fileUUID;
    },
  }))
  .actions(self => ({
    setUploadValue: (fileUUID: string, value: number) => {
      self.fileUUID = fileUUID;
      self.uploadValue = value;
    },
  }));

export default uploadFileProgress;
